import React, { useContext, useState } from "react";
import Input from "antd/lib/input";
import { api } from "../../api";
import { FormContext } from "../metadata/MDForm";
import _ from "lodash";
import {GA_PRODUCT_VERSION_KEY} from "../../utils/googleAnalyticsUtils";
const { Search } = Input;

const _manufacturerModelCache = {};
function getModel(VINValue) {
  const productVer = localStorage.getItem(GA_PRODUCT_VERSION_KEY);
  if (_manufacturerModelCache[`${VINValue}`])
    return Promise.resolve(_manufacturerModelCache[`${VINValue}`]);
  return api.get(`/vehicleModels?vin=${encodeURIComponent(VINValue)}&productVersionIdRef=${productVer}`).then(v => {
    _manufacturerModelCache[`${VINValue}`] = v;
    return v;
  }).catch(err=>err.response);
}

export const VINChoose = ({
  onChange,
  modelAttr,
  yearAttr,
  makeAttr,
  bodyStyleAttr,
  antiTheftAttr,
  antiLockAttr,
  restraintAttr,
  ...props
}) => {
  const [VINValue, setState] = useState(props.value);
  const [VINSearchLoading, setVINSearchLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  let { setValuesByAttr, setValueByAttr } = useContext(FormContext);
  const onVINChange = async (val) => {
    setVINSearchLoading(true)
    const response = await getModel(VINValue);
    if (response.status === 200){
      const { data } = response;
      if (_.isEmpty(data) || _.isEmpty(data.vehicleModelListItems)){
        resetStateAndShowError('VIN not found');
      }else {
        const modelAndEngineSize =  data ? `${data.vehicleModelListItems[0].vehicleModel.model}/${data.vehicleModelListItems[0].vehicleModel.engineSize}(${data.vehicleModelListItems[0].vehicleModel.engineCylinders})` : null
        setValuesByAttr({
          [modelAttr]: modelAndEngineSize,
          [yearAttr]: data.vehicleModelListItems[0].vehicleModel.modelYr.toString(),
          [makeAttr]: data.vehicleModelListItems[0].vehicleModel.manufacturer,
          [bodyStyleAttr]: data.vehicleModelListItems[0].vehicleModel.bodyStyle,
          [antiTheftAttr]: data.vehicleModelListItems[0].vehicleModel.antiTheft,
          [antiLockAttr]:  data.vehicleModelListItems[0].vehicleModel.antiLockBrakeSystem,
          [restraintAttr]:  data.vehicleModelListItems[0].vehicleModel.restraint,
        })
      }
    }else {
      resetStateAndShowError(response.data.message)
    }
    setVINSearchLoading(false)
    onChange(val);
  };

  const resetStateAndShowError = (errorMsg)=>{
    setValuesByAttr({
      [modelAttr]: null,
      [yearAttr]: null,
      [makeAttr]: null,
      'Vehicle.VehIdentificationNumber': null
    })
    setErrorMsg(errorMsg);
  }

  const onVINInputChange = (e) => {
    if (!e.target.value || e.target.value === '') {
        setValuesByAttr({
          [modelAttr]: null,
          [yearAttr]: null,
          [makeAttr]: null,
          'Vehicle.VehIdentificationNumber': null
        })
    }
    setState(e.target.value);
    setErrorMsg(null);
  };

  return (
    <>
      <div style={{ display: "flex", flexDirection: "row"}}>
        <Search
          {...props}
          value={VINValue}
          enterButton='Search'
          className={errorMsg ? 'has-error' : ''}
          onSearch={onVINChange}
          onChange={onVINInputChange}
          onPressEnter={onVINChange}
          loading={VINSearchLoading}
        />
      </div>
      <div style={{ flexDirection: 'column' }}>
        {errorMsg && (
            <span role={"alert"} className='fieldError'>{errorMsg}</span>
        )}
      </div>
    </>
  );
};
